import { render } from "./basebutton.vue?vue&type=template&id=73c979a8&scoped=true"
import script from "./basebutton.vue?vue&type=script&lang=js"
export * from "./basebutton.vue?vue&type=script&lang=js"

import "./basebutton.vue?vue&type=style&index=0&id=73c979a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c979a8"]])

export default __exports__